import { render, staticRenderFns } from "./bulk-dialog.vue?vue&type=template&id=2843bf41&scoped=true"
import script from "./bulk-dialog.vue?vue&type=script&lang=js"
export * from "./bulk-dialog.vue?vue&type=script&lang=js"
import style0 from "./bulk-dialog.vue?vue&type=style&index=0&id=2843bf41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2843bf41",
  null
  
)

export default component.exports